<template>
  <div>
    <template v-if="showSkeleton">
      <Table.Base :auto-columns="false">
        <Table.Headers>
          <Table.Header class="tablet-h:pl-[18px]">
            <Skeleton class="w-[85px] h-[13px]" />
          </Table.Header>
          <Table.Header class="hidden tablet-h:flex w-1/2!">
            <Skeleton class="w-[85px] h-[13px]" />
          </Table.Header>
        </Table.Headers>

        <Table.Row v-for="n in 4" :key="n">
          <Table.Cell class="tablet-h:pl-[18px]">
            <Skeleton class="w-[17px] h-6 mr-3" />
            <div>
              <Skeleton class="w-[100px] h-[13px] mb-2 tablet-h:mb-0" />
              <Skeleton class="tablet-h:hidden w-[150px] h-[13px]" />
            </div>
          </Table.Cell>
          <Table.Cell class="hidden tablet-h:flex w-1/2!">
            <Skeleton class="w-[150px] h-[13px]" />
          </Table.Cell>
        </Table.Row>
      </Table.Base>
    </template>

    <template v-else-if="showCombinedResults">
      <SearchItemsTable :items="items" :query="query" @close="handleClose" />
      <SearchFilesTables :files="files" :query="query" @close="handleClose" />
    </template>

    <SearchTokenTable
      v-else-if="token"
      :token="token"
      @close="handleClose"
      class="mt-3"
    />
  </div>
</template>

<script setup lang="ts">
import {
  type Item,
  type SearchFile,
  type SearchResult,
} from '@/shared/graphql/legacy/generated'
import { computed } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'
import SearchItemsTable from '@/features/search/components/SearchItemsTable.vue'
import SearchFilesTables from '@/features/search/components/SearchFilesTables.vue'
import SearchTokenTable from '@/features/search/components/SearchTokenTable.vue'
import { Skeleton, Table } from '@dacr/ui'

const props = defineProps<{
  data?: SearchResult
  query: string
}>()

const emit = defineEmits<{
  (e: 'clicked'): void
}>()

const device = useDevice()

const showSkeleton = computed(() => props.data === undefined)

const items = computed<Item[] | undefined>(() => {
  if (!props.data?.items?.length) return []

  const results = props.data.items

  if (device.isMobile.value || device.isTabletVertical.value) {
    return results.slice(0, 3)
  }

  return results
})

const files = computed<SearchFile[] | undefined>(() => {
  if (!props.data?.files?.length) return []

  const results = props.data.files

  if (device.isMobile.value || device.isTabletVertical.value) {
    return results.slice(0, 3)
  }

  return results
})

const token = computed<SearchFile | undefined>(() => {
  if (!props.data?.token) return

  return props.data.token
})

const showCombinedResults = computed(
  () => items.value !== undefined || files.value !== undefined
)

const handleClose = () => {
  emit('clicked')
}
</script>
